export type BranchStatus = "full" | "soon" | "open";
export type BranchStatusMap = { [id: string]: BranchStatus };

// API 실패/응답 전 폴백 (2026-07 API 값 기준 스냅샷)
const FALLBACK: BranchStatusMap = {
    daechi: "full", gangnam: "full", songpa: "full", bundang: "full", sinchon: "full",
    daegu: "full", centum: "full", hanam: "full", gangdong: "full",
    gimpo: "soon", dongtan: "open",
};

let cache: BranchStatusMap = FALLBACK;
let inflight: Promise<BranchStatusMap> | null = null;

export const getBranchRecruitmentStatus = (): BranchStatusMap => cache;

// 단일 비행(single-flight): App 로드 시점과 각 ConsultSheet 마운트가 모두 불러도 fetch는 세션당 1회
export const fetchBranchRecruitmentStatus = (): Promise<BranchStatusMap> => {
    if (!inflight) {
        inflight = fetch("https://peetsunbae.com/waiting/branch-recruitment-status")
            .then((r) => r.json())
            .then((result) => {
                if (result.message === "success" && result.statusMap) {
                    const next: BranchStatusMap = {};
                    Object.entries(result.statusMap).forEach(([loc, st]) => {
                        if (st === "full" || st === "soon" || st === "open") next[loc] = st;
                    });
                    // 폴백 위에 덮어써서 API 응답에 빠진 지점도 항상 배지를 가진다
                    if (Object.keys(next).length > 0) cache = { ...FALLBACK, ...next };
                }
                return cache;
            })
            .catch(() => cache); // 실패 시 폴백 유지
    }
    return inflight;
};
